import classNames from 'classnames';

function WidgetActions({ selectedData, currentStep, setCurrentStep, allSteps }) {
	const handleNextButton = () => {
		if (currentStep <= allSteps) {
			setCurrentStep(currentStep += 1)
		}
	}

	return (
		<div className="widget__actions">
			<div className="widget__actions-inner">
				{(currentStep > 1) && (
					<a
						href="#"

						className={classNames('btn btn--alt', { '': true })}
						onClick={(e) => {
							e.preventDefault();
							setCurrentStep(currentStep -= 1)
						}}
					>
						Back
					</a>
				)}

				<a
					href="#"
					className={classNames('btn', { 'disabled': !selectedData })}
					onClick={(e) => {
						e.preventDefault();
						handleNextButton();
					}}
				>
					{currentStep < allSteps ? (
						<>Next<span className='hidden-xs'>&nbsp;Step</span></>
					) : (
						<>Submit<span className='hidden-xs'>&nbsp;Your Request</span></>
					)}
				</a>
			</div>
		</div>
	);
}

export default WidgetActions;


